import { useNavigate } from 'react-router-dom'

import ArrowLeftIcon from 'assets/icons/ArrowLeft.png'
import ArrowIcon from 'assets/icons/ArrowRight.png'
import { Button } from 'components/Button'

import { ExplorePathways } from './pathways/ExplorePathways'
import { WorkingModeTable } from './WorkingModeTable'
import './workingModeSelection.scss'

export const WorkingModeSelection = () => {
  const navigate = useNavigate()

  return (
    <div className="working-mode-selection mx-auto flex flex-col items-center gap-10">
      <div className="flex flex-col gap-6 items-center text-center">
        <h1 className="headline-xl">Working Mode Selection</h1>
        <p className="body-m w-[912px]">
          Using the right approach is key to the success of your BVA journey. Explore these two recommended pathways and
          decide which one fits your needs.
        </p>
      </div>

      <WorkingModeTable />

      <ExplorePathways />

      <div className="flex justify-center gap-4">
        <Button
          text="Go to Project Set-Up"
          color="white"
          icon={<img src={ArrowLeftIcon} alt="Arrow Left" width="16" height="16" />}
          iconposition="left"
          className="px-[16px] py-[10px] border-2 z-[2]"
          onClick={() => navigate('/process?Project Set-Up')}
        />
        <Button
          text="Go to Insights Gathering"
          color="black"
          icon={<img src={ArrowIcon} alt="Arrow Left" width="16" height="16" />}
          iconposition="right"
          className="px-[16px] py-[10px] z-[2]"
          onClick={() => navigate('/process?Insights Gathering')}
        />
      </div>
    </div>
  )
}
